export const arrayRandomElement = (array) => {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
};

export const generateRange = (n) => {
  return Array.from({ length: n }, (_, index) => index + 1);
};

export const getCurrentTime = () => {
  const now = new Date();
  const hours = now.getHours() > 12 ? now.getHours() - 12 : now.getHours();
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const ampm = now.getHours() >= 12 ? 'pm' : 'am';

  return `${hours}:${minutes}${ampm}`;
}

// Compact, glanceable timestamp for queue rows: always "Jun 13 · 2:45pm"
// (date + time). Falls back to the raw value if unparseable.
export const formatQueueTime = (value) => {
  if (!value) return '';
  // Normalize "YYYY-MM-DD HH:MM:SS" (space-separated) to ISO so Safari/iOS
  // parses it — Safari returns Invalid Date for the space form.
  const normalized = typeof value === 'string'
    ? value.replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2})/, '$1T$2')
    : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return String(value);

  const hours12 = (date.getHours() % 12) || 12;
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'pm' : 'am';
  const time = `${hours12}:${minutes}${ampm}`;

  const day = date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `${day} · ${time}`;
}


export const loadImageAsDataUrl = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = function (error) {
      reject(error);
    };
    img.src = url;
  });
}

export const loadBlobAsDataURL = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}